import { render } from "./ResultRow.vue?vue&type=template&id=8c5f8dd8"
import script from "./ResultRow.vue?vue&type=script&lang=ts"
export * from "./ResultRow.vue?vue&type=script&lang=ts"
script.render = render

export default script